import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
	Avatar,
	Button,
	Chip,
	Modal,
	ModalBody,
	ModalContent,
	ModalHeader,
	Pagination,
	Select,
	SelectItem,
	Switch,
	Tabs,
	Tooltip,
	Tab,
	Spinner,
	Table,
	Alert,
	addToast,
	TableHeader,
	TableBody,
	TableRow,
	TableColumn,
	TableCell,
	ModalFooter,
} from "@heroui/react";
import { FansList } from "../components/RankDialog";
import LiveStatisticCard from "../components/LiveStatisticCard";
import { AnimatePresence, motion } from "framer-motion";
import { FansChart, GuardChart } from "../components/LineChart";
import DynamicCard from "../components/DynamicCard";
import HoverBioHistory from "../components/HoverBioHistory";
import MysteryBoxStatistic from "../components/MysteryBoxStatistic";
import { VirtuosoGrid } from "react-virtuoso";
import MixToolTip from "../components/MixToolTip";
import { eventBus } from "../App";
import Markdown from "react-markdown";
import FAV_CONTENT from "../assets/fav.md?raw";
import BVPlayer from "../components/BVPlayer";

function calcValid(array) {
	var count = 0;
	array.forEach((element) => {
		if (!inspectGuard(element)) {
			count++;
		}
	});

	return count;
}

function parseCharge(str) {
	var sum = 0;
	str.forEach((item) => {
		sum = sum + item.Count * item.Price;
	});
	return sum;
}
const formatDuration = (seconds) => {
	const h = Math.floor(seconds / 3600);
	const m = Math.floor((seconds % 3600) / 60);
	const s = seconds % 60;

	if (h > 0) {
		return `${h}:${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
	}
	return `${m}:${s.toString().padStart(2, "0")}`;
};
function LiverPage(props) {
	const [fansChart, setFansChart] = React.useState([]);

	const [guardChart, setGuardChart] = React.useState([]);

	const [space, setSpace] = React.useState({});

	const [lives, setLives] = React.useState([]);

	const [open, setOpen] = React.useState(false);

	const [guard, setGuard] = React.useState([]);

	const [guardTime, setGuardTime] = React.useState("");

	const redirect = useNavigate();

	const [orig, setOrig] = React.useState([]);

	const [noDM, setNoDM] = React.useState(false);

	const [month, setMonth] = useState(3);

	const [stream, setStream] = React.useState({});

	const [guild, setGuild] = React.useState([]);

	const [guardId, setGuardId] = React.useState("");

	const [load, setLoad] = React.useState(false);

	const [dynCount, setDynCount] = React.useState(0);

	const listRef = React.useRef();

	const [showAmount, setShowAmount] = React.useState(false);

	const [showHistoryBio, setShowHistoryBio] = React.useState(false);

	const [hideName, setHideName] = useState(false);

	let { id } = useParams();

	const [showMedals, setShowMedals] = React.useState(false);

	React.useEffect(() => {
		axios
			.create()
			.get(
				`https://fetch.danmakus.com/https://workers.vrp.moe/laplace/bilibili-user/${id}`,
			)
			.then((res) => {
				if (res.data.guildInfo != null) {
					setGuild(res.data.guildInfo.history);
				}
			});
		var handler = 0;
		axios
			.get(`${protocol}://${host}:${port}/api/liver/space?uid=${id}`)
			.then((response) => {
				setSpace(response.data);

				if (response.data.live_list?.length > 100) {
					setLives(response.data.live_list.slice(0, 80));
					handler = setTimeout(() => {
						setLives(response.data.live_list);
					}, 1200);
				} else {
					setLives(response.data.live_list);
				}
				if (!response.data.InFav) {
					eventBus.emit("showFavIcon");
				}
				if (response.data.Fans < 2000) {
					addToast({
						title: "有点底边了。。。",
						description: "所以TA的数据可能不完整",
						color: "danger",
					});
				}
				document.title = response.data.u_name + "的直播记录";
			});

		setTimeout(() => {
			setLoaded(true);
		}, 1500);
		const eventHandler = (e) => {
			setShowFavModal(true);
		};
		eventBus.on("favModalOpen", eventHandler);
		return () => {
			eventBus.off("favModalOpen");
			clearTimeout(handler);
		};
	}, []);

	React.useEffect(() => {
		axios
			.get(
				`${protocol}://${host}:${port}/api/liver/chart/fans?uid=${id}&month=${month}`,
			)
			.then((response) => {
				setFansChart(response.data.data ?? []);
			});

		axios
			.get(
				`${protocol}://${host}:${port}/api/liver/chart/guard?uid=${id}&month=${month}`,
			)
			.then((response) => {
				var dst = [];
				var map = [19998, 1998, 138];
				response.data.data?.forEach((element) => {
					dst.push({
						UpdatedAt: element.UpdatedAt,
						Guard: element.Guard.split(",").reduce(
							(a, b) => parseInt(a) + parseInt(b),
						),
						ID: element.ID,
					});
				});
				dst.sort((a, b) => a.Level > b.Level);
				setGuardChart(dst ?? []);
			});
	}, [noDM, month]);

	const [diffMode, setDiffMode] = React.useState(false);

	const [inspectMode, setInspectMode] = React.useState(false);

	const [showDyn, setShowDyn] = React.useState(false);

	const [dynList, setDynList] = React.useState([]);

	const [dynPage, setDynPage] = React.useState(1);

	const [loaded, setLoaded] = React.useState(false);

	const [showFavModal, setShowFavModal] = React.useState(false);

	React.useEffect(() => {
		if (guardId) {
			axios
				.get(`/api/liver/guard?id=${guardId}&inspect=true`)
				.then((response) => {
					var t = response.data.data;
					t.sort((a, b) => b.Level - a.Level);
					setGuard(t);
					setOrig(t);
					if (inspectMode) {
						setLoad(true);
					}
				});
		}
	}, [inspectMode]);

	const DYN_SIZE = 50;

	const [showBox, setShowBox] = useState(false);

	return (
		<div>
			<FavModal
				isOpen={showFavModal}
				onClose={() => {
					setShowFavModal(false);
				}}
				uid={id}
			/>
			<HistoryFlowModal
				uid={id}
				isOpen={showBox}
				onClose={() => {
					setShowBox(false);
				}}
				data0={space.history_amount}
				name={space.u_name}
			/>
			<Modal
				isOpen={open}
				onOpenChange={() => {
					if (open === true) {
						setInspectMode(false);
						setLoad(false);
					}
					setOpen(!open);
				}}
				className={`  grid transition-[grid-template-rows] duration-300 ease-out ${
					diffMode ? "grid-rows-[1fr]" : "grid-rows-[0fr] h-[75vh]"
				}`}
				scrollBehavior={"inside"}
			>
				<ModalContent>
					<ModalHeader className="flex flex-col gap-1 ">
						<span>{guardTime}</span>
						{inspectMode && load && (
							<span>
								{inspectMode &&
									`${calcValid(guard)} / ${guard.length}`}
							</span>
						)}
					</ModalHeader>
					<ModalBody>
						<div className={"scrollbar-hide"}>
							<div className={"flex flex-col"}>
								<Switch
									isSelected={diffMode}
									onValueChange={(e) => {
										setDiffMode(e);
										if (!e) {
											setGuard(orig);
										}
									}}
									isDisabled={inspectMode}
								>
									Diff
								</Switch>
								<Switch
									isSelected={inspectMode}
									onValueChange={(e) => {
										setInspectMode(e);
									}}
									className={"mt-2"}
									isDisabled={diffMode}
								>
									Inspect
								</Switch>
							</div>
							<AnimatePresence>
								{diffMode && (
									<motion.div
										key="select"
										initial={{ opacity: 0, y: -5 }}
										animate={{ opacity: 1, y: 0 }}
										exit={{ opacity: 0, y: -5 }}
										transition={{ duration: 0.2 }}
									>
										<Select className="mt-2">
											{guardChart
												.filter(
													(e) =>
														new Date(
															e.UpdatedAt,
														).getTime() >
														new Date(
															guardTime,
														).getTime(),
												)
												.map((e) => {
													var str = new Date(
														e.UpdatedAt,
													).toLocaleString();
													return (
														<SelectItem
															key={str}
															value={str}
															onPress={() => {
																axios
																	.get(
																		`${protocol}://${host}:${port}/api/guard?id=${e.ID}`,
																	)
																	.then(
																		(
																			response,
																		) => {
																			var dst =
																				response
																					.data
																					.data;
																			const oldIds =
																				new Set(
																					orig.map(
																						(
																							item,
																						) =>
																							item.UID,
																					),
																				);
																			const newIds =
																				new Set(
																					dst.map(
																						(
																							item,
																						) =>
																							item.UID,
																					),
																				);
																			const added =
																				dst
																					.filter(
																						(
																							item,
																						) =>
																							!oldIds.has(
																								item.UID,
																							),
																					)
																					.map(
																						(
																							item,
																						) => ({
																							...item,
																							Label: "add",
																						}),
																					);

																			const removed =
																				orig
																					.filter(
																						(
																							item,
																						) =>
																							!newIds.has(
																								item.UID,
																							),
																					)
																					.map(
																						(
																							item,
																						) => ({
																							...item,
																							Label: "remove",
																						}),
																					);
																			setGuard(
																				[
																					...added,
																					...removed,
																				],
																			);
																		},
																	);
															}}
															aria-label={""}
														>
															{str}
														</SelectItem>
													);
												})}
										</Select>
									</motion.div>
								)}
							</AnimatePresence>
						</div>
						<FansList
							fans={guard.slice(0, 1000)}
							height={620}
							onItemClick={(e) => {
								console.log(e);
								redirect("/user/" + e.UID);
							}}
							inspect={inspectMode}
						/>
					</ModalBody>
				</ModalContent>
			</Modal>
			<Modal
				isOpen={showDyn}
				onOpenChange={() => {
					setShowDyn(!showDyn);
				}}
				className={"overflow-x-hidden"}
				scrollBehavior={"inside"}
			>
				<ModalContent>
					<ModalHeader className="flex flex-col gap-1">
						<span>{space.UName}的历史动态</span>
					</ModalHeader>
					<ModalBody className={"overflow-x-hidden"}>
						<div ref={listRef}>
							{dynList
								.slice(
									(dynPage - 1) * DYN_SIZE,
									dynPage * DYN_SIZE,
								)
								.map((item, i) => {
									return (
										<DynamicCard
											item={item}
											key={item.OID || item.ID}
											onClick={() => {
												window.open(
													"https://t.bilibili.com/" +
														item.IDStr,
												);
											}}
										/>
									);
								})}
							<Pagination
								initialPage={1}
								total={Math.ceil(dynList.length / DYN_SIZE)}
								onChange={(e) => {
									setDynPage(e);
									listRef.current.parentElement.scrollTo({
										top: 0,
										behavior: "smooth",
									});
								}}
							/>
							;
						</div>
					</ModalBody>
				</ModalContent>
			</Modal>
			<div
				className={"flex flex-col mb-6 sm:justify-center items-center "}
			>
				<Avatar
					src={`${AVATAR_API}${id}`}
					size={"lg"}
					onClick={() => {
						toSpace(id);
					}}
					className={"cursor-pointer"}
				/>
				<div className={"ml-4 flex flex-col items-center"}>
					<span className={"font-bold"}>{space.u_name}</span>
					{space.verify && (
						<div className={"flex items-center"}>
							<svg
								style={{ color: "#ffcc00" }}
								width="16"
								height="16"
								viewBox="0 0 16 16"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z"
									fill="currentColor"
								></path>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M7.28832 12.7244C7.20127 12.767 7.1148 12.7988 7.02538 12.8C6.80863 12.8042 6.62919 12.6296 6.62564 12.4101C6.62742 12.3717 6.63512 12.3351 6.64814 12.2997L7.40676 8.78586L4.26392 8.79186C4.03651 8.79545 3.85825 8.6209 3.85352 8.40196C3.85588 8.27299 3.9228 8.15362 4.03118 8.08524L8.72206 3.2901C8.80852 3.23732 8.90149 3.20133 8.99743 3.20013C9.21477 3.19653 9.39303 3.37108 9.39776 3.59063C9.39599 3.65541 9.37822 3.71839 9.34506 3.77358L8.59118 7.23047H11.7388C11.9614 7.22687 12.1403 7.40142 12.1444 7.62096C12.1426 7.75113 12.0757 7.8705 11.9668 7.93888L7.28832 12.7244Z"
									fill="white"
								></path>
							</svg>
							<span className={"font-bold ml-2"}>
								{space.verify}
							</span>
						</div>
					)}
					{!!guild.length && (
						<MixToolTip
							content={
								<div className={"m-2"}>
									<div className={"mb-3"}>
										{guild.map((item, i) => {
											const updatedDate = new Date(
												item.updatedAt,
											).toLocaleDateString();
											return (
												<p
													key={item.name || i}
													className="flex items-center gap-4"
												>
													<span className="text-gray-400">
														{updatedDate}
													</span>
													<a
														href={`https://laplace.live/guilds/${item.name}`}
														className="text-blue-600 hover:underline"
													>
														{item.name}
													</a>
												</p>
											);
										})}
									</div>
									<span className={"mt-4"}>
										数据来自{" "}
										<a
											href={`https://laplace.live/user/${id}`}
											className="text-blue-600 hover:underline"
										>
											LAPLACE
										</a>
									</span>
								</div>
							}
						>
							<span className={"font-thin text-sm"}>
								公会：{guild[guild.length - 1].name}
							</span>
						</MixToolTip>
					)}
					<MixToolTip
						content={
							<HoverBioHistory
								uid={id}
								data0={space.history_bio}
							/>
						}
					>
						<span
							className={"font-thin text-sm"}
							onContextMenu={(e) => {
								e.preventDefault();
								setShowHistoryBio(!showHistoryBio);
							}}
						>
							{space.bio}
						</span>
					</MixToolTip>
				</div>
			</div>
			<div className="grid grid-cols-1 sm:grid-cols-3 gap-2 text-sm">
				<div className="rounded-xl bg-green-50  p-2 transition-transform duration-200 dark:bg-[#18181b] ">
					粉丝
					<br />
					<span className="font-semibold">
						{parseInt(space.fans).toLocaleString()}
					</span>
				</div>
				<div className="rounded-xl bg-yellow-50 dark:bg-[#18181b] p-2  ">
					大航海
					<br />
					<span className="font-semibold">{space.guard_count}</span>
				</div>
				<>
					<MixToolTip
						content={
							<HoverMedals2
								ruid={id}
								onMouseLeave={() => {
									setShowMedals(false);
								}}
								data0={{
									list: space.medal_list,
									group: space.medal_same?.group ?? [],
									count: space.medal_count,
								}}
							/>
						}
						delay={100}
						placement={""}
						isOpen={showMedals}
						classNames={{
							content: "w-fit p-0",
						}}
						offset={20}
					>
						<div className="rounded-xl bg-pink-50 dark:bg-[#18181b] p-2 transition-transform duration-200  hover:bg-pink-100 ">
							粉丝牌
							<br />
							<span className="font-semibold">
								{hideName
									? "*".repeat(
											(space.medal_name ?? "").length,
										)
									: (space.medal_name ?? "")}
							</span>
						</div>
					</MixToolTip>
				</>
			</div>
			<div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm mt-4">
				<div
					onClick={() => {
						setShowDyn(true);
						const start = new Date().getTime();
						axios
							.get("/api/liver/dynamics?uid=" + id)
							.then((res) => {
								console.log(new Date().getTime() - start);
								var array = res.data.data;
								var m = new Map();
								array.forEach((element) => {
									m.set(element.ID, element);
								});
								console.log(new Date().getTime() - start);
								array.forEach((element) => {
									if (element.ForwardFrom !== 0) {
										element.ForwardDynamic = m.get(
											element.ForwardFrom,
										);
									}
								});
								console.log(new Date().getTime() - start);

								var newArray = [];
								var v0 = parseInt(id);
								array.forEach((element) => {
									if (element.UID === v0) {
										newArray.push(element);
									}
								});
								console.log(new Date().getTime() - start);
								setDynList(newArray);
								console.log(new Date().getTime() - start);
							});
					}}
					className="rounded-xl bg-blue-50 dark:bg-[#18181b] p-2 transition-all duration-200  hover:bg-blue-100 "
				>
					动态
					<br />
					<span className="font-semibold">
						{parseInt(space.dyn_count).toLocaleString()}
					</span>
				</div>
				<div
					className="rounded-xl bg-yellow-50 dark:bg-[#18181b] p-2 transition-transform duration-200  hover:bg-yellow-100"
					onMouseEnter={() => {
						setShowAmount(true);
					}}
					onMouseLeave={() => {
						setShowAmount(false);
					}}
					onClick={() => {
						setShowBox(true);
					}}
				>
					30日内流水
					<br />
					<Tooltip
						placement="right"
						offset={30}
						content={
							<div>
								<p className={""}>
									30日内开播时长：
									{(function calc() {
										var seconds = 0;
										var now = Date.now();
										var thirtyDaysMs =
											30 * 24 * 3600 * 1000;
										var cutoff = now - thirtyDaysMs;

										space.live_list?.forEach((element) => {
											var startMs =
												element.StartAt * 1000 -
												3600 * 8 * 1000;
											if (
												element.EndAt !== 0 &&
												startMs >= cutoff
											) {
												seconds +=
													element.EndAt -
													(element.StartAt -
														8 * 3600);
											}
										});
										return (
											(seconds / 3600).toFixed(1) + "h"
										);
									})()}
								</p>
								<p className={"mb-2.5"}>
									本月开播天数：
									{(function calc() {
										//开播的当天算一天，即使播到第二天也算一天。
										//如果从第一天播到第三天就会不对，，，

										function getDaysInMonth(year, month) {
											return new Date(
												year,
												month,
												0,
											).getDate();
										}
										var now = new Date();
										var days = new Array(
											getDaysInMonth(
												now.getFullYear(),
												now.getMonth() + 1,
											),
										).fill(0);
										space.Lives?.forEach((element) => {
											var start = new Date(
												element.StartAt * 1000 -
													8 * 3600 * 1000,
											);

											if (
												start.getFullYear() ===
													now.getFullYear() &&
												start.getMonth() ===
													now.getMonth()
											) {
												days[start.getDate()] = 1;
											}
										});
										return `${days.reduce((accumulator, current) => accumulator + current, 0)}/${getDaysInMonth(now.getFullYear(), now.getMonth() + 1)}`;
									})()}
								</p>
								<p className={"mb-0.5"}>
									礼物/SC流水{" "}
									{parseInt(
										space.amount - space.guard_sum,
									).toLocaleString()}
								</p>
								<p className={"mb-0.5"}>
									大航海流水{" "}
									{parseInt(space.guard_sum).toLocaleString()}
								</p>
								{space &&
									space.charge &&
									space.charge !== "null" && (
										<p className={"mb-1.5"}>
											充电流水：
											{parseCharge(
												space.charge ?? {},
											).toLocaleString()}
										</p>
									)}
							</div>
						}
						isOpen={showAmount}
						onOpenChange={(o) => setShowAmount(o)}
					>
						<span
							className="font-semibold cursor-pointer"
							onContextMenu={(e) => {
								e.preventDefault();
								setShowAmount(!showAmount);
							}}
						>
							{(
								(space &&
								space.charge &&
								space.charge !== "null"
									? parseCharge(space.charge)
									: 0) + parseInt(space.amount)
							).toLocaleString()}
						</span>
					</Tooltip>
				</div>
			</div>
			<div>
				<Button
					onClick={(e) => {
						setMonth(month + 3);
					}}
					className={"mt-2"}
				>
					更多
				</Button>
			</div>
			<div className={"grid grid-cols-1 sm:grid-cols-2 w-full"}>
				<div className="h-[300px]">
					<FansChart data={fansChart} />
				</div>
				<div className="h-[300px]">
					<GuardChart
						data={guardChart}
						onClick={(index) => {
							setGuardTime(
								new Date(
									guardChart[index].UpdatedAt,
								).toLocaleString(),
							);
							axios
								.get(
									`/api/liver/guard?id=${guardChart[index].ID}`,
								)
								.then((response) => {
									var t = response.data.data;
									t.sort((a, b) => b.Level - a.Level);
									setGuard(t);
									setOrig(t);
									setOpen(true);
									setGuardId(guardChart[index].ID);
								});
						}}
					/>
				</div>
			</div>
			<Switch
				onValueChange={(value) => {
					setNoDM(value);
					axios
						.get(
							`${protocol}://${host}:${port}/api/live/list?uid=${id}&limit=1000&no_dm=${value}`,
						)
						.then((response) => {
							setLives(response.data.lives);
						});
				}}
				defaultSelected={false}
			>
				显示所有场次
			</Switch>
			{true ? (
				<div className="grid 2xl:grid-cols-4 lg:grid-cols-4 gap-4">
					{lives?.map((live, index) => (
						<LiveStatisticCard
							item={live}
							showUser={false}
							key={live.ID}
							allowClick={!noDM}
						/>
					))}
				</div>
			) : (
				<VirtuosoGrid
					useWindowScroll
					data={lives}
					listClassName="grid 2xl:grid-cols-4 sm:grid-cols-4 gap-4 p-2"
					itemContent={(index, e) => (
						<LiveStatisticCard
							item={e}
							showUser={false}
							key={e.ID}
							allowClick={!noDM}
						/>
					)}
				/>
			)}
		</div>
	);
}
function HoverMedals2(props) {
	var [data, setData] = useState([]);
	const [group, setGroup] = useState([]);
	const [total, setTotal] = useState(0);
	const [alive, setAlive] = useState(0);
	const [loading, setLoading] = useState(true);
	useEffect(() => {
		if (props.data0) {
			setData(props.data0.list);
			setTotal(props.data0.count.total);
			setAlive(props.data0.count.active);
			setGroup(props.data0.group ?? []);
			setLoading(false);
			return;
		}
		axios
			.get(
				`${protocol}://${host}:${port}/api/fansRank?liver=${props.ruid}&size=100&page=1`,
			)
			.then((response) => {
				if (response.data.list == null) {
					response.data.list = [];
				}
				response.data.list.sort((a, b) => {
					return a.Score < b.Score;
				});
				response.data.list.forEach((element) => {
					element.Liver = element.UName;
					element.LiverID = element.UID;
				});
				setData(response.data.list);
				setTotal(response.data.total);
				setAlive(response.data.alive);
				setGroup(response.data.group ?? []);
				setLoading(false);
			});
	}, []);
	return (
		<div
			className={"flex flex-col overflow-scroll  overflow-x-hidden "}
			onMouseLeave={() => {
				props.onMouseLeave();
			}}
			style={{ maxHeight: "600px" }}
		>
			{loading && <Spinner />}
			{!loading && (
				<Tabs>
					<Tab
						key={"list"}
						title={`粉丝团（${formatNumber(alive)}/${formatNumber(total)}）`}
					>
						{data.map((item, index) => (
							<div key={index} className={"mt-2 ml-1.5"}>
								<div className={"flex flex-row"}>
									<p className={"font-bold"}>{item.UName}</p>
									{!item.CreatedAt.includes("0001-01-01") && (
										<p
											className={
												"ml-1.5 text-[11px] text-gray-500"
											}
										>
											{new Date(
												item.CreatedAt,
											).toLocaleString()}
										</p>
									)}
								</div>

								<div
									className={
										"flex flex-row align-middle mt-2"
									}
								>
									<Avatar
										src={`${AVATAR_API}${item.UID}`}
										onClick={() => {
											window.open("/user/" + item.UID);
										}}
										className={"cursor-pointer"}
									/>

									{item.Level ? (
										<Chip
											startContent={
												item.Type ? (
													<img
														src={getGuardIcon(
															item.Type,
														)}
														className={"w-6 h-6"}
													/>
												) : (
													<div />
												)
											}
											variant="faded"
											onClick={() => {
												window.open(
													"/liver/" + item.LiverID,
												);
											}}
											style={{
												background:
													new Date().getTime() -
														new Date(
															item.UpdatedAt,
														) >
													168 * 2 * 3600 * 1000
														? "#5762A799"
														: getColor(item.Level),
												color: "white",
												marginLeft: "8px",
											}}
										>
											{item.MedalName}
											<span className="ml-2 text-xs font-bold px-2 py-0.5 rounded-full">
												{item.Level}
											</span>
										</Chip>
									) : (
										<></>
									)}
								</div>
							</div>
						))}
					</Tab>
					<Tab key={"group"} title={"粉丝团重合"}>
						{group.map((item, index) => (
							<div key={item.liver_id} className={"mt-2 ml-1.5"}>
								<p className={"font-bold"}>{item.liver}</p>

								<div
									className={
										"flex flex-row items-center  w-full"
									}
								>
									<div className={" align-middle mt-2"}>
										<Avatar
											src={`${AVATAR_API}${item.liver_id}`}
											onClick={() => {
												toSpace(item.liver_id);
											}}
										/>
									</div>
									<span className={"ml-3 font-bold"}>
										{((item.cnt / alive) * 100).toFixed(2)}%
									</span>
								</div>
								<div className="mt-2 h-1.5 w-full rounded-full bg-emerald-100/60 dark:bg-emerald-950/40">
									<div
										className="h-1.5 rounded-full bg-emerald-500 dark:bg-emerald-400 transition-all duration-300"
										style={{
											width: `${alive > 0 ? ((item.cnt / alive) * 100).toFixed(2) : 0}%`,
										}}
									/>
								</div>
							</div>
						))}
						<Alert
							description={`仅展示重合度大于15%的主播`}
							title={""}
							hideIcon={true}
							className={"mt-1"}
						/>
					</Tab>
				</Tabs>
			)}
		</div>
	);
}

function HistoryFlowModal({ uid, isOpen, onClose, name, data0 }) {
	const [data, setData] = useState([]);
	useEffect(() => {
		if (data0) {
			setData(data0);
		} else {
			if (isOpen) {
				axios.get("/api/liver/flow?uid=" + uid).then((response) => {
					setData(response.data.data);
				});
			}
		}
	}, [uid, isOpen]);

	const columns = [
		{
			key: "year",
			label: "年",
		},
		{
			key: "month",
			label: "月",
		},
		{
			key: "live",
			label: "礼物/SC",
		},
		{
			key: "charge",
			label: "充电",
		},
		{
			key: "guard",
			label: "大航海",
		},
		{
			key: "sum",
			label: "总和",
		},
	];

	return (
		<Modal isOpen={isOpen} onClose={onClose}>
			<ModalContent>
				<ModalHeader>{name} 的 历史流水</ModalHeader>
				<ModalBody>
					{data && data.length && (
						<Table aria-label="Example table with dynamic content">
							<TableHeader columns={columns}>
								{(column) => (
									<TableColumn key={column.key}>
										{column.label}
									</TableColumn>
								)}
							</TableHeader>
							<TableBody items={data}>
								{(item) => (
									<TableRow key={item.Year + item.Month}>
										<TableCell>{item.Year}</TableCell>
										<TableCell>{item.Month}</TableCell>
										<TableCell>
											{formatNumber(item.Live)}
										</TableCell>
										<TableCell>
											{formatNumber(item.Charge)}
										</TableCell>
										<TableCell>
											{formatNumber(item.GuardSum)}
										</TableCell>
										<TableCell>
											{formatNumber(
												item.Live +
													item.Charge +
													item.GuardSum,
											)}
										</TableCell>
									</TableRow>
								)}
							</TableBody>
						</Table>
					)}
				</ModalBody>
			</ModalContent>
		</Modal>
	);
}

function FavModal({ isOpen, onClose, uid }) {
	const [seconds, setSeconds] = React.useState(5);
	useEffect(() => {
		if (!isOpen) {
			setSeconds(5);
			return;
		}
		const timer = setInterval(() => {
			setSeconds((prev) => {
				if (prev <= 1) {
					clearInterval(timer);
					return 0;
				}
				return prev - 1;
			});
		}, 1000);
		return () => clearInterval(timer);
	}, [isOpen]);
	return (
		<div className={"markdown-body list-disc"}>
			<Modal isOpen={isOpen} onClose={onClose}>
				<ModalContent>
					<ModalHeader>添加主播</ModalHeader>
					<ModalBody>
						<Markdown
							components={{
								ul: ({ node, ...props }) => (
									<ul
										style={{
											listStyleType: "disc",
											paddingLeft: "2em",
											marginTop: "6px",
										}}
										{...props}
									/>
								),
								li: ({ node, ...props }) => (
									<li
										style={{
											marginTop: "12px",
										}}
										{...props}
									/>
								),
								a: ({ node, ...props }) => (
									<a
										className="text-blue-500 hover:text-blue-700 hover:underline"
										target="_blank"
										rel="noreferrer"
										{...props}
									/>
								),
							}}
						>
							{FAV_CONTENT}
						</Markdown>
					</ModalBody>
					<ModalFooter>
						<Button
							color="danger"
							variant="light"
							onClick={onClose}
						>
							取消
						</Button>
						<Button
							color={"primary"}
							isDisabled={seconds > 0}
							onPress={() => {
								axios
									.post(
										"/api/trace_mng/submit",
										new URLSearchParams({
											uid: uid,
										}),
									)
									.then(() => {
										onClose();
										addToast({
											title: "添加成功",
											color: "success",
										});
										setTimeout(() => {
											location.reload();
										}, 1500);
									});
							}}
						>
							提交{seconds > 0 ? `（${seconds}秒）` : ""}
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</div>
	);
}

export default LiverPage;
